function hovering(_this) {
  $(_this).removeClass("hovered hovering").addClass("hovering");
}

function hovered(_this) {
  $(_this
  ).addClass("hovered").removeClass("hovering").delay(300).queue(function () {
    $(_this).removeClass("hovered").dequeue();
  });
}

$(document).ready(function () {

  var userAgent = navigator.userAgent;
  var item = $(".hover");
  $('.footer_toTop').click(function(){
    $('html, body').animate({scrollTop: 0}, 500);
});


  if (userAgent.indexOf("iPhone") >= 0 || userAgent.indexOf("iPad") >= 0 || userAgent.indexOf("Android") >= 0) {
    item.on("touchstart", function () {
      hovering(this)
    });
    item.on("touchend", function () {
      hovered(this)
    });
  } else {
    item.hover(
      function () {
        hovering(this)
      },
      function () {
        hovered(this)
      }
    )
  };
});



